import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: "/", redirect: "/home" },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/individualRent",
    name: "IndividualRent",
    component: () => import("../views/IndividualRent.vue"),
    meta: {
      title: "个人租",
    },
  },
  {
    path: "/information",
    name: "information",
    component: () => import("../views/information.vue"),
    meta: {
      title: "迪瓜资讯",
    },
  },
  {
    path: "/IndividualRentDetail",
    name: "IndividualRentDetail",
    component: () => import("../views/IndividualRentDetail.vue"),
    meta: {
      title: "商品详情",
    },
  },
  {
    path: "/SettledDigua",
    name: "SettledDigua",
    component: () => import("../views/SettledDigua.vue"),
    meta: {
      title: "赋能保障",
    },
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/Contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
    meta: {
      title: "联系我们",
    },
  },
  {
    path: "/white",
    name: "white",
    component: () => import("../views/Contact.vue"),
    meta: {
      title: "联系我们",
    },
  },
];

const router = new VueRouter({
  routes
})
// 添加全局导航守卫
router.beforeEach((to, from, next) => {
  console.log(to)
  // if(to)
  // 重置滚动位置到顶部
  window.scrollTo(0, 0);
  next();
});
export default router
